import { render, staticRenderFns } from "./Legend.vue?vue&type=template&id=10dd0a68&scoped=true"
import script from "./Legend.vue?vue&type=script&setup=true&lang=js"
export * from "./Legend.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Legend.vue?vue&type=style&index=0&id=10dd0a68&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dd0a68",
  null
  
)

export default component.exports